const STATUS_MESSAGES = {
  400: 'We were unable to process that request. Please try again.',
  404: 'Whoops! The file you\'re looking for can\'t be found!',
  500: 'Oh no! We\'re currently experiencing issues on our end. Please try again.',
  520: 'An unexpected error occurred, please try again.',
};

export default (statusCode, fallback = 'Oops, we ran into an issue. Please try again.') => (
  STATUS_MESSAGES[statusCode] || fallback
);
